import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { axiosAtheneum } from '../../../../axios';
import { moduleName } from '../../moduleInfo';
import {
  athCoursesListRoute,
  createOffer,
  deleteOffer,
  getOffers,
  getOffersDetails,
  getUserDetails,
  updateOfferStatus,
  updateOneOffer,
} from '../../utils/apiRoutes';

export const getAllOffersAsync = createAsyncThunk(
  `${moduleName}/getAllOffersAsync`,
  async (payload) => {
    const { params } = payload;
    const response = await axiosAtheneum({
      method: 'GET',
      url: getOffers(),
      params: { ...params },
    });
    const data = response.data;
    return data;
  }
);

export const getOfferDetailsAsync = createAsyncThunk(
  `${moduleName}/getOfferDetailsAsync`,
  async (id) => {
    const response = await axiosAtheneum({
      method: 'GET',
      url: getOffersDetails(id),
    });
    const data = response.data;
    return data;
  }
);

export const getUserDetailsAsync = createAsyncThunk(
  `${moduleName}/getUserDetailsAsync`,
  async (payload) => {
    const { params } = payload;
    const response = await axiosAtheneum({
      method: 'GET',
      url: getUserDetails(),
      params: { ...params },
    });
    const data = response.data;
    return data;
  }
);

export const getProductListAsync = createAsyncThunk(
  `${moduleName}/getProductListAsync`,
  async () => {
    const response = await axiosAtheneum({
      method: 'GET',
      url: athCoursesListRoute(),
    });
    const data = response.data;
    return data;
  }
);

export const createOfferAsync = createAsyncThunk(
  `${moduleName}/createOfferAsync`,
  async (payload) => {
    const response = await axiosAtheneum({
      method: 'POST',
      url: createOffer(),
      data: payload,
    });
    const data = response.data;
    return data;
  }
);

export const updateOfferStatusAsync = createAsyncThunk(
  `${moduleName}/updateOfferStatusAsync`,
  async (payload) => {
    const response = await axiosAtheneum({
      method: 'POST',
      url: updateOfferStatus(),
      data: payload,
    });
    const data = response.data;
    return data;
  }
);

export const updateOfferAsync = createAsyncThunk(
  `${moduleName}/updateOfferAsync`,
  async (payload) => {
    const response = await axiosAtheneum({
      method: 'PATCH',
      url: updateOneOffer(payload._id),
      data: payload,
    });
    const data = response.data;
    return data;
  }
);

export const deleteOfferAsync = createAsyncThunk(
  `${moduleName}/deleteOfferAsync`,
  async (id) => {
    const response = await axiosAtheneum({
      method: 'DELETE',
      url: deleteOffer(id),
    });
    const data = response.data;
    return data;
  }
);

const OfferSlice = createSlice({
  name: `${moduleName}/Offer`,
  initialState: {
    loading: false,
    offers: [],
    offer: null,
    offerDetails: null,
    offerStatus: null,
    usersDetails: null,
    productList: null,
  },
  reducers: {},
  extraReducers: {
    [getAllOffersAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [getAllOffersAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.offers = action.payload;
    },
    [getAllOffersAsync.rejected]: (state, action) => {
      state.loading = false;
    },

    [getOfferDetailsAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [getOfferDetailsAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.offerDetails = action.payload;
    },
    [getOfferDetailsAsync.rejected]: (state, action) => {
      state.loading = false;
    },

    [getUserDetailsAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [getUserDetailsAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.usersDetails = action.payload;
    },
    [getUserDetailsAsync.rejected]: (state, action) => {
      state.loading = false;
    },

    [getProductListAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [getProductListAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.productList = action.payload;
    },
    [getProductListAsync.rejected]: (state, action) => {
      state.loading = false;
    },

    [createOfferAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [createOfferAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.offer = action.payload;
    },
    [createOfferAsync.rejected]: (state, action) => {
      state.loading = false;
    },

    [updateOfferStatusAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [updateOfferStatusAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.offerStatus = action.payload;
    },
    [updateOfferStatusAsync.rejected]: (state, action) => {
      state.loading = false;
    },

    [deleteOfferAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [deleteOfferAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.offer = action.payload;
    },
    [deleteOfferAsync.rejected]: (state, action) => {
      state.loading = false;
    },

    [updateOfferAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [updateOfferAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.offer = action.payload;
    },
    [updateOfferAsync.rejected]: (state, action) => {
      state.loading = false;
    },
  },
});

export default OfferSlice.reducer;
